import { render, staticRenderFns } from "./UserLogout.vue?vue&type=template&id=d07bc06a&scoped=true"
import script from "./UserLogout.vue?vue&type=script&lang=js"
export * from "./UserLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07bc06a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d07bc06a')) {
      api.createRecord('d07bc06a', component.options)
    } else {
      api.reload('d07bc06a', component.options)
    }
    module.hot.accept("./UserLogout.vue?vue&type=template&id=d07bc06a&scoped=true", function () {
      api.rerender('d07bc06a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/UserLogout.vue"
export default component.exports